module.exports = ".text-form {\n  font-size: 0.75rem;\n  font-weight: 500;\n  line-height: 0.875rem;\n  color: #929292;\n  position: relative;\n}"